/** Liest den Passwort-Token aus dem URL-Fragment (`#t=<token>`, siehe auth-contract.md „Seiten-URLs“). */
export const readTokenFromHash = (hash: string): string | undefined => {
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash)
    const token = params.get("t")
    return token ? token : undefined
}

/**
 * Entfernt das Fragment aus der Adresszeile, ohne neuen History-Eintrag und ohne den History-State von react-router zu verlieren.
 * So bleibt der Token weder in der Adresszeile noch im Verlauf (Zurück-Taste). Die Router-Location zieht PasswordSet per `navigate(..., { replace: true })` nach.
 */
export const removeHashFromUrl = () => {
    if (!window.location.hash) return
    window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search)
}
